import React, { useState, useContext, useEffect, useRef } from "react";
import Header from "./userheader";
import Footer from "./userfooter";
import toast, { Toaster } from "react-hot-toast";
import CryptoJS from 'crypto-js';
import config from "../../coreFIles/config";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  Modal,
  Button,
  Spinner
} from "react-bootstrap";
import { CurrencyContext } from "../../currencyConvertor/CurrencyContext";
import GuestFormGlobal from "./GuestFormGlobal";
import { bookInit, priceRecommendation, hotelBooking, checkCashbackBalance, checkSubsForDiscount } from "../../Action/user.action";
import { useNavigate } from 'react-router-dom';
import { facPayment, insertBookingData } from "../../Action/user.action";
import Cookies from "js-cookie";

const loginData = !Cookies.get("loginSuccessPropertyOwner")
  ? []
  : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

const ZenPayment = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [merchantData, setMerchantData] = useState({});
  const [propertyData, setPropertyData] = useState({});
  const [status, setStatus] = useState(false);
  const [guestData, setGuestData] = useState(null);
  const [latestPriceInfo, setLatestPriceInfo] = useState({});
  const [paypalReady, setPaypalReady] = useState(false);
  const [bookingId, setBookingId] = useState()
  const [isSoldOut, setIsSoldOut] = useState(false)
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const { currency, convertPrice } = useContext(CurrencyContext);
  const [discount, setDiscount] = useState(0);
  const [subsDetail, setSubsDetail] = useState({})
  const [isPropertyOwner, setIsPropertyOwner] = useState(0);

  const location = window.location;
  const queryParams = new URLSearchParams(location.search);
  const data = queryParams.get('data');
  const guestDataRef = useRef(guestData);
  const bookingRefId = useRef(bookingId)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleFacShow = () => setFacShow(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMerchantData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    guestDataRef.current = guestData;
  }, [guestData]);

  useEffect(() => {
    bookingRefId.current = bookingId;
  }, [bookingId]);

  useEffect(() => {
    const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'your-secret-key-12345';
    const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    setPropertyData(JSON.parse(decryptedString));
  }, [data]);

  useEffect(() => {
    const fetchData = async () => {
      if (propertyData?.hotelId) {
        let res = await priceRecommendation({ data: propertyData });
        let latestPriceInfo = res?.data || {};
        if (latestPriceInfo?.message == "The hotel you selected is soldout") {
          setIsSoldOut(true)
        }
        setLatestPriceInfo(latestPriceInfo);
        setBookingId(Math.floor(1000 + Math.random() * 9000).toString())
      }
    };
    fetchData();
  }, [propertyData]);



  useEffect(() => {
    if (propertyData?.selectedRoom?.price > 0) {
      setPaypalReady(true);
    }
  }, [propertyData]);

  const createOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          description: 'Hotel Booking Payment',
          amount: {
            currency_code: "USD",
            value: finalAmount.toFixed(2),
          },
        },
      ],
    });
  };

  const onApprove = async (data, actions) => {
    try {
      setIsProcessingPayment(true);
      toast.loading('Processing your payment...');

      const bookingInitResult = await initateBooking();

      if (!bookingInitResult || bookingInitResult.bookingStatus !== 'Initiated') {
        toast.error('Failed to initiate booking');
        setIsProcessingPayment(false);
        toast.dismiss();
        return;
      }

      const captureData = await actions.order.capture();

      if (captureData.status === "COMPLETED") {
        const res = await handleBooking();
        let bookingResult = res?.data || {};
        if (bookingResult && bookingResult.bookingStatus === 'Confirmed') {
          toast.dismiss();
          toast.success('Booking completed successfully!');
          setTimeout(() => {
            navigate(`${config.baseUrl}userdashboard/hotelbooking`);
          }, 2000);
        } else {
          toast.dismiss();
          toast.error('Booking confirmation failed');
        }
      } else {
        toast.dismiss();
        toast.error('Payment not completed');
      }
    } catch (error) {
      console.error('Payment processing error:', error);
      toast.dismiss();
      toast.error('Error processing payment');
    } finally {
      setIsProcessingPayment(false);
    }
  };

  const onError = (err) => {
    console.error('PayPal error:', err);
    toast.dismiss();
    toast.error('Error with PayPal payment');
    setIsProcessingPayment(false);
  };

  console.log("guestData in initateBooking", guestData);


  const initateBooking = async () => {
    try {
      const guestData = guestDataRef.current;
      const booking_id = bookingRefId.current;
      if (!guestData) {
        toast.error('Please fill in guest details first');
        return;
      }

      const bookingData = {
        hotelId: propertyData.hotelId,
        roomId: propertyData.selectedRoom.roomId,
        rateIds: propertyData.selectedRoom.rateId,
        checkin: propertyData.checkin,
        checkout: propertyData.checkout,
        token: propertyData.token,
        guestData: guestData,
        bookingRefId: booking_id,
        bookingFor: 4,
        userId: loginData?.id,
        amount: propertyData?.selectedRoom?.price,
        propertyData: propertyData,
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: isPropertyOwner === 1 ? subsDetail?.bookingDiscount || 0 : 0,
        discountAmount: isPropertyOwner === 1 ? discount : 0,
        isPropertyOwner: isPropertyOwner
      };

      try {
        const res = await bookInit({ bookingData: bookingData });
        return res.data;
      } catch (error) {
        console.error('Booking init error:', error);
        toast.error('Failed to initiate booking');
        return null;
      }
    } catch (error) {
      console.error('Error in initateBooking:', error);
      toast.error('Error initiating booking');
      return null;
    }
  };

  const handleBooking = async () => {

    const guestData = guestDataRef.current;
    const bookingId = bookingRefId.current
    if (!guestData) {
      toast.error('Please fill in guest details first');
      return;
    }

    try {
      const bookingData = {
        hotelId: propertyData.hotelId,
        roomId: propertyData.selectedRoom.roomId,
        rateIds: propertyData.selectedRoom.rateId,
        checkin: propertyData.checkin,
        checkout: propertyData.checkout,
        token: propertyData.token,
        guestData: guestData,
        bookingRefId: bookingId,
        bookingFor: 4,
        userId: loginData?.id,
        amount: latestPriceInfo?.price,
        baseAmt: propertyData?.selectedRoom?.basePrice,
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: isPropertyOwner === 1 ? subsDetail?.bookingDiscount || 0 : 0,
        discountAmount: isPropertyOwner === 1 ? discount : 0,
        isPropertyOwner: isPropertyOwner

      };

      const res = await hotelBooking({ bookingData: bookingData });
      return res;
    } catch (error) {
      console.error('Booking error:', error);
      toast.error('Booking failed');
      return null;
    }
  };

  const [Facshow, setFacShow] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [checkoutForm, setCheckoutForm] = useState({
    cardholderName: "",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    amount: "",
  });

  const [emptyFields, setEmptyFields] = useState([]);
  const handleFacClose = () => {
    setCheckoutForm({})
    setFacShow(false)
    setEmptyFields([])
  };

  const handleFACChange = (e) => {
    const { id, value } = e.target;
    setCheckoutForm({ ...checkoutForm, [id]: value });

    if (emptyFields.includes(id)) {
      setEmptyFields(emptyFields.filter((field) => field !== id));
    }
  };

  const handleFACPayment = async (e) => {
    e.preventDefault();
    let errors = {};

    const requiredFields = ["cardholderName", "cardNumber", "expiryDate", "cvv", "firstName", "lastName", "email"];
    requiredFields.forEach(field => {
      if (!checkoutForm[field] || checkoutForm[field].trim() === '') {
        errors[field] = `This field is required.`;
      }
    });

    const cardNumber = (checkoutForm.cardNumber || "").replace(/\s|-/g, '');
    if (cardNumber.length !== 16) {
      errors.cardNumber = "Card Number must be 16 digits.";
    }

    const expiryDate = (checkoutForm.expiryDate || "").trim();
    const expiryPattern = /^\d{2}\/(0[1-9]|1[0-2])$/;

    if (!expiryPattern.test(expiryDate)) {
      errors.expiryDate = "Expiration Date must be in YY/MM format.";
    }

    const cvv = (checkoutForm.cvv || "").trim();
    if (cvv.length !== 3 && cvv.length !== 4) {
      errors.cvv = "CVV must be 3 or 4 digits.";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors({});

    const bookingAmt = parseFloat(propertyData?.selectedRoom?.price).toFixed(2);

    try {
      const bookingData = {
        hotelId: propertyData.hotelId,
        roomId: propertyData.selectedRoom.roomId,
        rateIds: propertyData.selectedRoom.rateId,
        checkin: propertyData.checkin,
        checkout: propertyData.checkout,
        token: propertyData.token,
        guestData: guestData,
        bookingRefId: bookingId,
        bookingFor: 4,
        userId: loginData?.id,
        amount: bookingAmt,
        checkOutDetails: checkoutForm,
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: isPropertyOwner === 1 ? subsDetail?.bookingDiscount || 0 : 0,
        discountAmount: isPropertyOwner === 1 ? discount : 0,
        isPropertyOwner: isPropertyOwner
      };

      const bookingInitResult = await initateBooking();

      if (!bookingInitResult || bookingInitResult.bookingStatus !== 'Initiated') {
        toast.error('Failed to initiate booking');
        return;
      }
      if (bookingInitResult.bookingStatus == 'Initiated') {
        let facRes = await facPayment(bookingData)
        if (facRes.data && facRes.data.RedirectData) {
          setCheckoutForm({});
          setFacShow(false);
          setEmptyFields([]);
          const redirectHTML = facRes.data.RedirectData;

          const blob = new Blob([redirectHTML], { type: "text/html" });
          const url = URL.createObjectURL(blob);

          window.location.href = url;
        } else {
          alert("No redirect data received for 3DS authentication.");
        }
      } else {
        toast.error('Failed to initate Payment')
      }
    } catch (error) {
      console.error("Error during FAC payment:", error);
    }
  };

  //-------------------|| Cashback Balance ||-------------------

  const [cashbackBalance, setCashbackBalance] = useState(0);
  const [useCashback, setUseCashback] = useState(false);
  const [cashbackApplied, setCashbackApplied] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);

  useEffect(() => {
    fetchCashbackBalance();
    fetchSubsForDiscount()
  }, []);

  const fetchCashbackBalance = async () => {
    try {
      const res = await checkCashbackBalance()
      if (res.success) {
        setCashbackBalance(res.data.balance);
      }
    } catch (error) {
      console.error("Error fetching cashback balance:", error);
    }
  };

  // Calculate total amount without cashback
  const calculateTotalAmount = () => {

    const totalAmount = propertyData?.selectedRoom?.price
    return totalAmount;

  };

  const calculateMaxCashback = () => {
    const totalAmount = calculateTotalAmount();
    // Maximum cashback is 50% of total or available balance, whichever is lower
    const maxCashback = Math.min(cashbackBalance, totalAmount * 0.5);
    return maxCashback;
  };

  // Handle cashback checkbox change
  const handleCashbackChange = (e) => {
    const shouldUseCashback = e.target.checked;
    setUseCashback(shouldUseCashback);

    if (shouldUseCashback) {
      const maxCashback = calculateMaxCashback();
      setCashbackApplied(maxCashback);

      // Calculate final amount after cashback
      const totalAmount = calculateTotalAmount();
      setFinalAmount(Math.max(0, totalAmount - maxCashback));
    } else {
      setCashbackApplied(0);
      setFinalAmount(calculateTotalAmount());
    }
  };

  // Update final amount when total amount changes
  useEffect(() => {
    const totalAmount = calculateTotalAmount();
    if (useCashback) {
      setFinalAmount(Math.max(0, totalAmount - cashbackApplied));
    } else {
      setFinalAmount(totalAmount);
    }
  }, [useCashback, cashbackApplied]);

  useEffect(() => {
    const calculateFinalAmount = () => {
      const baseAmount = propertyData?.selectedRoom?.price || 0;
      let discountAmount = 0;
      let finalAmount = baseAmount;

      if (isPropertyOwner === 1 && subsDetail?.bookingDiscount > 0) {
        discountAmount = (baseAmount * (subsDetail.bookingDiscount || 0)) / 100;
        finalAmount = baseAmount - discountAmount;
        setDiscount(discountAmount);
      }

      // Apply cashback for non-property owners
      if (isPropertyOwner === 0 && useCashback) {
        const maxCashback = Math.min(cashbackBalance, baseAmount * 0.5);
        finalAmount = Math.max(0, baseAmount - maxCashback);
        setCashbackApplied(maxCashback);
      }

      setFinalAmount(finalAmount);
    };

    calculateFinalAmount();
  }, [propertyData, isPropertyOwner, subsDetail, useCashback, cashbackBalance]);


  const fetchSubsForDiscount = async () => {
    try {
      const res = await checkSubsForDiscount();
      if (res.success && res.data) {
        setSubsDetail(res.data);
        setIsPropertyOwner(1);
      } else {
        setSubsDetail(null);
        setIsPropertyOwner(0);
      }
    } catch (error) {
      console.error("Error fetching subscription detail:", error);
      setIsPropertyOwner(0);
    }
  };


  return (
    <>
      <Header />
      <div>
        <Toaster />
        {isProcessingPayment && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '8px',
              textAlign: 'center',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
            }}>
              <Spinner animation="border" variant="primary" />
              <p className="mt-3">Processing your payment...</p>
            </div>
          </div>
        )}

        <section className="yourbooking pt-5 pb-5 overflow-hidden vh-80">
          <Container>
            <div className="">
              <Row className=" ">
                <Col lg={7} className="mb-4">
                  {typeof propertyData.roomCount !== 'undefined' && (
                    <GuestFormGlobal
                      onStatusChange={(status) => setStatus(status)}
                      onSubmitFormData={(data) => setGuestData(data)}
                      // noOfRoomBooked={propertyData.totalAdults + propertyData.totalChildren}
                      occupancies={latestPriceInfo?.hotel?.rates[0].occupancies}
                      rateId={propertyData.selectedRoom.rateId}
                    />
                  )}
                  {guestData && (
                    <div className="p-3">
                      <div className="heading border-bottom border-secondary pt-2 pb-2">
                        <h5><b>Payment</b></h5>
                      </div>
                      <div className="mt-4">
                        <h6 className="mb-2"><b>Pay With:</b></h6>
                      </div>

                      {!latestPriceInfo.hotel.rates[0].cardRequired && paypalReady && (
                        <PayPalScriptProvider
                          options={{
                            "client-id": config.CLIENT_ID,
                            components: "buttons",
                            intent: "capture",
                            enableFunding: "card",
                            "disable-funding": "venmo,paylater"
                          }}
                        >
                          <PayPalButtons
                            style={{ layout: "vertical" }}
                            className="paypal-buttons"
                            createOrder={createOrder}
                            onApprove={onApprove}
                            onError={onError}
                            disabled={isProcessingPayment}
                            forceReRender={[finalAmount, useCashback, cashbackApplied]}

                          />
                        </PayPalScriptProvider>
                      )}
                    </div>
                  )}
                </Col>

                <Col lg={5} className="mb-4">
                  <div className="text-end">
                    {isSoldOut && (
                      <img
                        src="/images/soldout.jpg"
                        alt="Sold Out"
                        className="img-fluid sold-out-tag"
                        style={{ maxHeight: '100px', maxWidth: '100px' }}
                      />
                    )}
                  </div>
                  <Card>
                    <div className="paymentImg">
                      {propertyData?.selectedRoom?.images?.length > 0 && (
                        <img
                          src={propertyData.selectedRoom.images[0].fileNameImage}
                          alt={propertyData.selectedRoom.roomName || "Room Image"}
                          className="img-fluid"
                        />
                      )}
                    </div>
                    <div className="px-2">
                      <div className="mt-4">
                        <div>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="fw-bold mb-0">{propertyData.hotelName}</h5>
                            <h6
                              className={`fw-bold mb-0 ${propertyData.selectedRoom?.refundable ? 'text-success' : 'text-danger'
                                }`}
                            >
                              {propertyData.selectedRoom?.refundable ? 'Refundable' : 'Non-Refundable'}
                            </h6>
                          </div>
                          <h6 className="mb-0">{propertyData.address}</h6>
                        </div>
                      </div>
                      <hr />
                      <div className="">
                        <Row>
                          <Col lg={6}>
                            <div>
                              <div><b>Check-in</b></div>
                              <p className="text-grey mb-0">{propertyData?.checkin || "N/A"}</p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Checkout</b></div>
                              <p className="text-grey mb-0">{propertyData?.checkout || "N/A"}</p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Rooms</b></div>
                              <p className="text-grey mb-0">
                                {propertyData.totalRooms} Rooms
                              </p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Guests</b></div>
                              <p className="text-grey mb-0">
                                {(() => {
                                  return `${propertyData.totalAdults} Adults`;
                                })()}
                              </p>
                            </div>
                          </Col>

                          <Col lg={4}>
                            <div>
                              <div><b>Children</b></div>
                              <p className="text-grey mb-0">
                                {(() => {
                                  return `${propertyData.totalChildren} Children`;
                                })()}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </div>
                      <hr />
                      <div className="mt-4 mb-1">
                        <Row>
                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <h6>Booking Amount</h6>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <span className="text-grey">
                              + ${convertPrice(propertyData?.selectedRoom?.basePrice)} {currency}
                            </span>
                          </Col>

                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <h6>Taxes & Other Charges</h6>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <span className="text-grey">
                              + ${convertPrice((propertyData?.selectedRoom?.price - propertyData?.selectedRoom?.basePrice)) || 0} {currency}
                            </span>
                          </Col>

                          <Col lg={6} sm={6} xs={6} className="mb-2 ">
                            <h5><b>Total Cost:</b></h5>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <h5 className="fw-bold">
                              ${convertPrice(propertyData?.selectedRoom?.price)} {currency}
                            </h5>
                          </Col>

                          {isPropertyOwner === 1 && subsDetail?.bookingDiscount > 0 && (
                            <>
                              <Row className="mb-2">
                                <Col lg={6} sm={6} xs={6} className="mb-2">
                                  <h6>Discount ({subsDetail.bookingDiscount}%)</h6>
                                </Col>
                                <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                                  <span className="text-success">
                                    -${convertPrice(discount)} {currency}
                                  </span>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col lg={6} sm={6} xs={6} className="mb-2">
                                  <h5>
                                    <b>Final Amount:</b>
                                  </h5>
                                </Col>
                                <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                                  <h5 className="fw-bold text-dark">
                                    ${convertPrice(finalAmount)} {currency}
                                  </h5>
                                </Col>
                              </Row>
                            </>
                          )}

                          {isPropertyOwner === 0 && (
                            <>
                              {cashbackBalance > 0 && (
                                <Row className="mt-3">
                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <div className="d-flex align-items-center">
                                      <Form.Check
                                        type="checkbox"
                                        id="use-cashback"
                                        checked={useCashback}
                                        onChange={handleCashbackChange}
                                        className="me-2"
                                      />
                                      <Form.Label htmlFor="use-cashback" className="mb-0">
                                        Use Cashback Balance
                                      </Form.Label>
                                    </div>
                                    <small className="text-muted">
                                      Available: ${convertPrice(cashbackBalance)} {currency}
                                    </small>
                                  </Col>
                                  <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                                    {useCashback ? (
                                      <span className="text-success">
                                        -${convertPrice(cashbackApplied)} {currency}
                                      </span>
                                    ) : (
                                      <span className="text-grey">
                                        ${convertPrice(0)} {currency}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                              )}

                              {(useCashback) && (
                                <Row>
                                  <Col lg={6} sm={6} xs={6} className="mb-2">
                                    <h5>
                                      <b>Final Amount:</b>
                                    </h5>
                                  </Col>
                                  <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                                    <h5 className="fw-bold text-primary">
                                      ${convertPrice(finalAmount)} {currency}
                                    </h5>
                                  </Col>
                                </Row>
                              )}
                            </>
                          )}
                        </Row>
                      </div>
                    </div>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
      </div>

      <Modal show={show} onHide={handleClose} size="md">
        <Modal.Header closeButton className="border-0 position-relative z-2">
        </Modal.Header>
        <Modal.Body style={{ marginTop: "-38px" }}>
          <div className="text-center mb-3">
            <div className="mb-2">
              <img
                src="images/mmg-logo.png"
                alt="MMG Logo"
                style={{ height: "50px" }}
              />
            </div>
            <h4 className="fw-semibold mb-2">Initiate Payment</h4>
            <h6 className="fw-semibold mb-2">Property Nu</h6>
          </div>
          <div>
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Customer MMG Number</Form.Label>
                <Form.Control
                  type="text"
                  id="customerId"
                  name="customerId"
                  placeholder="MMG Number"
                  value={merchantData.customerId}
                  onChange={handleChange}
                  className="rounded-1"
                />
              </Form.Group>
              <div className="text-center">
                <Button
                  variant="primary"
                  onClick={() => { }}
                  className="rounded-1"
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={Facshow} onHide={handleFacClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold lh-1"><div>Checkout form</div> <span className="x-small h5">Please fill out the form below to complete your purchase.</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="cardholderName">
                  <Form.Label>Cardholder Name</Form.Label>
                  <Form.Control type="text"
                    placeholder="Enter name"
                    id="cardholderName"
                    value={checkoutForm.cardholderName}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("cardholderName") ? "red" : "" }} />
                  {validationErrors.cardholderName && (
                    <div className="text-danger small">{validationErrors.cardholderName}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="cardNumber">
                  <Form.Label>Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="0000 0000 0000 0000"
                    id="cardNumber"
                    value={checkoutForm.cardNumber}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, '');
                      const formattedValue = rawValue.replace(/(.{4})/g, '$1 ').trim();
                      handleFACChange({ target: { id: 'cardNumber', value: formattedValue } });
                    }}
                    maxLength={19}
                    style={{ borderColor: emptyFields.includes("cardNumber") ? "red" : "" }}
                    onKeyPress={(event) => {
                      if (!/\d/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  {validationErrors.cardNumber && (
                    <div className="text-danger small">{validationErrors.cardNumber}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="expiryDate">
                  <Form.Label>Expiration Date (YYMM)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="YY/MM"
                    id="expiryDate"
                    value={checkoutForm.expiryDate}
                    onChange={(e) => {
                      let raw = e.target.value.replace(/\D/g, '').slice(0, 4);
                      let formatted = '';
                      if (raw.length >= 3) {
                        formatted = raw.slice(0, 2) + '/' + raw.slice(2, 4);
                      } else {
                        formatted = raw;
                      }
                      handleFACChange({ target: { id: 'expiryDate', value: formatted } });
                    }}
                    maxLength={5}
                    style={{ borderColor: emptyFields.includes("expiryDate") ? "red" : "" }}
                  />
                  {validationErrors.expiryDate && (
                    <div className="text-danger small">{validationErrors.expiryDate}</div>
                  )}
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group controlId="cvv">
                  <Form.Label>Security Code (CVV2)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="CVV"
                    id="cvv"
                    value={checkoutForm.cvv}
                    onChange={(e) => {
                      const raw = e.target.value.replace(/\D/g, '');
                      const cvvValue = raw.slice(0, 4);
                      handleFACChange({ target: { id: 'cvv', value: cvvValue } });
                    }}
                    maxLength={4}
                    style={{ borderColor: emptyFields.includes("cvv") ? "red" : "" }}
                  />
                  {validationErrors.cvv && (
                    <div className="text-danger small">{validationErrors.cvv}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="amount">
                  <Form.Label>Amount to pay</Form.Label>
                  <Form.Control
                    type="Number"
                    placeholder="e.g. 100.00 USD"
                    id="amount"
                    value={parseFloat(propertyData?.selectedRoom?.price) > 0 ? parseFloat(propertyData?.selectedRoom?.price).toFixed(2) : ""}
                  />
                </Form.Group>
              </Col>
            </Row>

            <h5 className="mt-4"><strong>Billing Details</strong></h5>

            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="firstName">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="firstName"
                    placeholder="Enter first name"
                    value={checkoutForm.firstName}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("firstName") ? "red" : "" }} />
                  {validationErrors.firstName && (
                    <div className="text-danger small">{validationErrors.firstName}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="lastName">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    id="lastName"
                    placeholder="Enter last name"
                    value={checkoutForm.lastName}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("lastName") ? "red" : "" }} />
                  {validationErrors.lastName && (
                    <div className="text-danger small">{validationErrors.lastName}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={6}>
                <Form.Group controlId="email">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    id="email"
                    placeholder="Enter email"
                    value={checkoutForm.email}
                    onChange={handleFACChange}
                    style={{ borderColor: emptyFields.includes("email") ? "red" : "" }}
                  />
                  {validationErrors.email && (
                    <div className="text-danger small">{validationErrors.email}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Button variant="primary" type="button" className="w-100" onClick={handleFACPayment}>
              Confirm Payment
            </Button>

            <div className="text-center mt-4">
              <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg" alt="Visa" height="30" className="mx-2" />
              <img src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png" alt="MasterCard" height="30" className="mx-2" />
              <img src="images/american_exp.webp" alt="AMEX" height="30" className="mx-2" />
            </div>

            <div className="text-center mt-2 text-muted" style={{ fontSize: '14px' }}>
              <p>
                POWERED BY <img src="images/Powertranz-Logo.png" alt="PowerTranz" style={{ height: '23px', verticalAlign: 'middle' }} />
              </p>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};

export default ZenPayment;